import { render, staticRenderFns } from "./WorkTokens.vue?vue&type=template&id=2a78b032&lang=pug&"
import script from "./WorkTokens.vue?vue&type=script&lang=js&"
export * from "./WorkTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports